import { CategoryTypeDto } from '@ebf/features/category-types/domain';
import { ChampionshipDto } from '@ebf/features/championships/domain';
import { CountryDto } from '@ebf/features/countries/domain';
import { RoundCriteriaDto } from '@ebf/features/round-criteria/domain';
import { UserDto } from '@ebf/features/users/domain';

export enum ChampionshipCategoryStatus {
  REGISTRATION = 'REGISTRATION',
  READY_TO_OPEN = 'READY_TO_OPEN',
  OPEN = 'OPEN',
  EVALUATION = 'EVALUATION',
  EVALUATED = 'EVALUATED',
  COMPLETED = 'COMPLETED',
  SKIPPED = 'SKIPPED',
}

export interface ChampionshipRoundDto {
  readonly uuid: string;
  readonly title: string;
  readonly acceptanceCriterion: string;
  readonly category: Partial<ChampionshipCategoryDto>;
  readonly criteria: RoundCriteriaDto[];
  readonly venueCriteria?: RoundCriteriaDto[];
  readonly availableLanguages: {
    readonly code: string;
    readonly label: string;
  }[];
  readonly modelRound: boolean;
  readonly online: boolean;
  readonly startDate: string;
  readonly startTime: string;
  readonly winnersAllowed: number;
  readonly duration: number;
  readonly status: ChampionshipCategoryStatus;
  readonly conflicts: boolean;
  readonly autoCompletable: boolean;
  readonly active: boolean;
}

export interface ChampionshipCategoryDto {
  readonly uuid: string;
  readonly categoryType: CategoryTypeDto;
  readonly championship: ChampionshipDto;
  readonly description: string;
  readonly startDate: string;
  readonly startTime: string;
  readonly status: ChampionshipCategoryStatus;
  readonly conflict: string;
  readonly configured: boolean;
  readonly updatedBy: Partial<UserDto>;
  readonly updatedAt: number;
  readonly name?: string;
  readonly latexRound: ChampionshipRoundDto;
  readonly modelRound: ChampionshipRoundDto;
  readonly onlineLatexRound: ChampionshipRoundDto;
  readonly onlineModelRound: ChampionshipRoundDto;
  readonly countryChampionships: {
    readonly uuid: string;
    readonly title: string;
    readonly country: CountryDto;
    readonly parentChampionship: ChampionshipDto;
  }[];
  readonly totals: {
    readonly roundsTotal: number;
    readonly countryChampionshipsTotal: number;
    readonly contestantsTotal: number;
  };
}
